// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"b9d5a4e6","399":"92cb5bd4","453":"164137df","645":"27e5c688","818":"64b574e2","899":"3bb85aae"}[chunkId] + ".chunk.js";
};